"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sant-ambrogio-di-valpolicella": {
    "san-giorgio": [{
      "hkey": "b867a39d",
      "slug": "san-giorgio-di-valpolicella",
      "name": "San Giorgio di Valpolicella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c4c28281": [{
      "hkey": "fce13a03",
      "slug": "domegliana-ponton",
      "name": "Domegliana-Ponton",
      "primary": true,
      "skipSearch": false
    }],
    "domegliara": [{
      "hkey": "fce13a03",
      "slug": "domegliana-ponton",
      "name": "Domegliana-Ponton",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "174a639c": [{
      "hkey": "fce13a03",
      "slug": "domegliana-ponton",
      "name": "Domegliana-Ponton",
      "primary": true,
      "skipSearch": false
    }],
    "ponton": [{
      "hkey": "fce13a03",
      "slug": "domegliana-ponton",
      "name": "Domegliana-Ponton",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "sant-ambrogio-di-valpolicella"
    }],
    "d2c1c723": [{
      "hkey": "b867a39d",
      "slug": "san-giorgio-di-valpolicella",
      "name": "San Giorgio di Valpolicella",
      "primary": true,
      "skipSearch": false
    }]
  }
};
exports["default"] = _default;